import { useState } from "react";
import { api, formatApiErrorDetail } from "../../lib/api";
import AdminInvoices from "../../pages/admin/AdminInvoices";
import { primaryClass, WorkflowError, yen } from "./shared";

export const InvoicePanel = ({ data, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  const candidates = data.estimates.filter(e => e.status === "成約" && !data.invoices.some(i => i.estimate_id === e.id && i.status !== "取消"));
  const create = async est => {
    setBusy(true); setError("");
    try { await api.post(`/admin/estimates/${est.id}/create-invoice`); await onChanged(); setRevision(r => r + 1); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return <div className="space-y-6">
    {!data.workflow.delivery && <p data-testid="workflow-invoice-before-delivery" className="border-l-2 border-amber-400 pl-3 text-sm text-amber-300">納品記録が未登録です。前受金など、納品前に請求が必要な場合も登録できます。</p>}
    {candidates.map(est => <div key={est.id} data-testid={`workflow-invoice-candidate-${est.id}`} className="flex flex-wrap items-center justify-between gap-4 border-b border-line pb-5">
      <p className="text-sm text-gray-300">受注見積　{est.estimate_number}<span className="mt-1 block font-bold text-white">{est.title}　{yen(est.total)}</span></p>
      <button data-testid={`workflow-create-invoice-${est.id}`} onClick={() => create(est)} disabled={busy} className={primaryClass}>この見積から請求書を作成</button>
    </div>)}
    <WorkflowError error={error} id="workflow-invoice-error" />
    <AdminInvoices key={revision} project={data.project} onChanged={onChanged} />
  </div>;
};